module.exports = __webpack_public_path__ + "static/assets/6249ca5409d2db0058666e2420ba5cb3.svg";